import axiosInstance from '@/lib/axios'; // Your configured axiosInstance instance





export async function getLobbyDetailsFromInvite() {
    const response = await axiosInstance.get("/match/lobby/invite_details", {}); // no payload

    return response.data;
}



export async function leaveInviteLobby(match_id) {

    const response = await axiosInstance.delete(`/match/lobby/members/leave/${match_id}`);


    return response.data.permission === false ? false : true;


}







